import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';


const SubmitReview = () => {
  const { film_id } = useParams(); // Get the film ID from the URL
  const [review, setReview] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [feedbackCategories, setFeedbackCategories] = useState([]); // State for feedback categories
  const [notes, setNotes] = useState(''); // State for filmmaker's notes
  const [title, setTitle] = useState('Untitled Film'); // State for film title
  const [youtubeLink, setYoutubeLink] = useState(''); // State for YouTube link
  const [isAnimating, setIsAnimating] = useState(false); // State for animation
      const [film, setFilm] = useState(null);
      const [hoveredRating, setHoveredRating] = useState({}); // Initialize as an empty object
      const [currentRatings, setCurrentRatings] = useState({}); // Track current ratings per review
  const [comments, setComments] = useState({}); // Store comments for each review
  const [newComment, setNewComment] = useState(''); // Store the new comment being typed
  const navigate = useNavigate();

  // Fetch film details to get feedback categories and notes
  useEffect(() => {
    const fetchFilmDetails = async () => {
   try {
        const token = localStorage.getItem('token'); // Retrieve the JWT token from localStorage
        const response = await axios.get(`${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/films/${film_id}`, {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
          },
        });

        const filmData = response.data;
        setFilm(filmData);
        
        setNotes(filmData.notes || '');

        filmData.reviews.forEach((review) => {
          fetchCommentsForReview(review.id);
        });
       
      // Set additional states
      setFeedbackCategories(filmData.feedback_categories || []);
      setTitle(filmData.title || 'Untitled Film');
      setYoutubeLink(filmData.youtube_link || '');

      // Initialize current ratings for each review
      const initialRatings = {};
      filmData.reviews.forEach((review) => {
        initialRatings[review.id] = review.current_user_rating || 0; // Use existing rating if available
      });
      setCurrentRatings(initialRatings);
    } catch (err) {
        console.error('Error fetching film details:', err);
        setError(err.response?.data?.error || 'Failed to fetch film details.');
      }
    };


    fetchFilmDetails();
  }, [film_id]);


    const [isLoggedIn, setIsLoggedIn] = useState(false);

      useEffect(() => {
        setIsLoggedIn(!!localStorage.getItem('token'));
    }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate word count
    const wordCount = review.trim().split(/\s+/).length;
    if (wordCount < 100) {
      setError('Feedback is too short. Minimum 100 words required.');
      return;
    }
    if (wordCount > 2000) {
      setError('Feedback is too long. Maximum 2000 words allowed.');
      return;
    }

    try {
      const token = localStorage.getItem('token'); // JWT token for authentication
      const user_id = localStorage.getItem('user_id'); // Get the user ID from localStorage

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/submit-review`,
        { film_id, reviewer_id: user_id, review },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log('Feedback submitted successfully:', response.data);
      setSuccess(response.data.message);
      setError('');
      setReview('');

     // Trigger animation
     setIsAnimating(true);

     // Redirect to the film details page after 3 seconds
     setTimeout(() => {
       setIsAnimating(false); // Reset animation
       navigate(`/films/${film_id}`);
     }, 3000);
    } catch (err) {
      console.error('Error submitting feedback:', err);
      setError(err.response?.data?.error || 'Failed to submit feedback.');
      setSuccess('');
    }
  };

  const fetchCommentsForReview = async (reviewId) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/reviews/${reviewId}/comments`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setComments((prev) => ({ ...prev, [reviewId]: response.data.comments || [] }));
  } catch (err) {
    console.error(`Error fetching comments for feedback ${reviewId}:`, err);
  }
};

const handleSubmitComment = async (reviewId) => {
  const commentText = newComment[reviewId]?.trim();
  if (!commentText || commentText.split(/\s+/).length > 200) {
    setError('Comment is too long. Maximum 200 words allowed.');
    return;
  }

  try {
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('user_id');

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/reviews/${reviewId}/comments`,
      { user_id: userId, comment: commentText },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log('Comment submitted successfully:', response.data);

    // Update the comments state
    setComments((prev) => ({
      ...prev,
      [reviewId]: [...(prev[reviewId] || []), response.data.comment],
    }));

    setNewComment((prev) => ({ ...prev, [reviewId]: '' })); // Clear the comment input for this review
    setError('');
    setSuccess('Comment added successfully!');
  } catch (err) {
    console.error('Error submitting comment:', err);
    setError(err.response?.data?.error || 'Failed to submit comment.');
    setSuccess('');
  }
};

  const handleMouseEnter = (reviewId, star) => {
    setHoveredRating((prev) => ({ ...prev, [reviewId]: star }));
  };

  const handleMouseLeave = (reviewId) => {
    setHoveredRating((prev) => ({ ...prev, [reviewId]: null }));
  };

  if (error) {
    return <p style={{ color: 'red' }}>{error}</p>;
  }

  if (!film) {
    return <p>Loading film details...</p>;
  }

  const handleRateReview = async (reviewId, rating) => {
  try {
    const token = localStorage.getItem('token'); // JWT token for authentication
    const userId = localStorage.getItem('user_id'); // Get the user ID from localStorage

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/reviews/${reviewId}/rate`,
      { user_id: userId, rating },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log('Rating submitted successfully:', response.data);

    // Update the currentRatings state to reflect the new rating
    setCurrentRatings((prevRatings) => ({
      ...prevRatings,
      [reviewId]: rating,
    }));

    setSuccess('Rating updated successfully!');
    setError('');
  } catch (err) {
    console.error('Error submitting rating:', err);
    setError(err.response?.data?.error || 'Failed to submit rating.');
    setSuccess('');
  }
};

  return (
    <div
      style={{
        display: 'flex',
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        color: '#333',
        lineHeight: '1.6',
        backgroundColor: '#f9f9f9',
        minHeight: '100vh',
        animation: isAnimating ? 'fadeOut 3.1s ease-in-out' : 'fadeIn 0s ease-in-out',
      }}
    >
      {/* Main content */}
      <div style={{ flex: 3, marginRight: '20px' }}>
        <h1 style={{ color: '#007bff', marginBottom: '20px' }}>Submit Feedback</h1>
  
        {error && (
          <p
            style={{
              color: 'red',
              backgroundColor: '#ffe6e6',
              padding: '10px',
              borderRadius: '5px',
              border: '1px solid #ffcccc',
            }}
          >
            {error}
          </p>
        )}
        {success && (
          <p
            style={{
              color: 'green',
              backgroundColor: '#e6ffe6',
              padding: '10px',
              borderRadius: '5px',
              border: '1px solid #ccffcc',
            }}
          >
            {success}
          </p>
        )}
  
        {/* Display filmmaker's notes */}
        {notes && (
          <div
            style={{
              marginBottom: '20px',
              padding: '15px',
              border: '1px solid #ccc',
              borderRadius: '5px',
              backgroundColor: '#f3e5f5', // Light purple for Filmmaker's Notes
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            }}
          >
            <h2 style={{ color: '#7b1fa2', marginBottom: '10px' }}>Filmmaker's Notes</h2>
            <p style={{ margin: 0 }}>{notes}</p>
          </div>
        )}
  
        {isLoggedIn ? (
        <form onSubmit={handleSubmit} style={{
            padding: '20px',
            border: '1px solid #ccc',
            borderRadius: '10px',
            backgroundColor: '#ede7f6', // Slightly darker purple for the review form
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          <div style={{ marginBottom: '15px' }}>
            <textarea
              id="review"
              value={review}
              onChange={(e) => setReview(e.target.value)}
              rows="10"
              cols="50"
              placeholder="Write your feedback here..."
              required
              style={{
                width: '98%',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '5px',
                fontSize: '16px',
                fontFamily: 'Arial, sans-serif',
                backgroundColor: '#e8eaf6', // Lightest purple for the textarea
              }}
            />
          </div>
          <div
            style={{
              textAlign: 'right',
              fontSize: '14px',
              color: review.trim().split(/\s+/).length < 100 ? '#dc3545' : '#28a745', // Red if less than 100 words, green otherwise
              marginBottom: '10px',
            }}
          >
            Word Count: {review.trim().split(/\s+/).filter((word) => word).length} / 100
          </div>
          <button
            type="submit"
            style={{
              padding: '10px 15px',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              fontSize: '16px',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = '#218838')}
            onMouseLeave={(e) => (e.target.style.backgroundColor = '#28a745')}
          >
            Submit Feedback
          </button>
          </form>
          ) : (
            <p style={{ color: '#555', textAlign: 'center', marginBottom: '30px' }}>
               Please <Link to="/login" style={{ color: '#007bff' }}>create an account or sign in</Link> to leave feedback.
            </p>
          )}

      {/* Reviews Section */}
      <h2 style={{ textAlign: 'center', color: '#333', marginBottom: '20px' }}>Feedbacks</h2>
      {film.reviews.length > 0 ? (
        <ul
          style={{
            listStyle: 'none',
            padding: 0,
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '20px',
          }}
        >
          {film.reviews.map((review) => (
            <li
              key={review.id}
              style={{
                backgroundColor: '#ffffff',
                padding: '15px',
                borderRadius: '10px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              }}
            >
              <p>
                <strong>Reviewer:</strong> {review.reviewer_username}
              </p>
              <div
                style={{
                  margin: '10px 0',
                  fontStyle: 'italic',
                  color: '#555',
                }}
              >
                {review.review.split('\n').map((line, index) => (
                  <p key={index} style={{ margin: '5px 0' }}>
                    {line}
                  </p>
                ))}
              </div>

             <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: '10px',
              }}
            >
             {isLoggedIn && (
                <>
                  <label style={{ marginRight: '10px', fontWeight: 'bold', color: '#333' }}>
                    Rate this feedback:
                  </label>
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span
                      key={star}
                      onMouseEnter={() => handleMouseEnter(review.id, star)}
                      onMouseLeave={() => handleMouseLeave(review.id)}
                      onClick={() => handleRateReview(review.id, star)}
                      style={{
                        cursor: 'pointer',
                        fontSize: '24px',
                        color: star <= (hoveredRating[review.id] || currentRatings[review.id] || 0) ? 'gold' : 'gray',
                        marginRight: '5px',
                        transition: 'color 0.2s',
                      }}
                    >
                      ★
                    </span>
                  ))}
                </>
              )}
             </div>

{/* Comments Section for Each Review */}
    <div style={{ marginTop: '20px' }}>
      <h3 style={{ marginBottom: '10px', color: '#333' }}>Comments</h3>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {(comments[review.id] || []).map((comment, index) => (
          <li
            key={index}
            style={{
              backgroundColor: '#f9f9f9',
              padding: '10px',
              borderRadius: '5px',
              marginBottom: '10px',
              border: '1px solid #ddd',
            }}
          >
            <p style={{ margin: 0 }}>
              <strong>{comment.username}:</strong> {comment.comment}
            </p>
          </li>
        ))}
      </ul>

      {/* Add Comment Form */}
      {isLoggedIn && (
        <>
      <textarea
        value={newComment[review.id] || ''} // Use review-specific comment state
        onChange={(e) =>
          setNewComment((prev) => ({ ...prev, [review.id]: e.target.value }))
        }
        rows="3"
        placeholder="Add a comment..."
        style={{
          width: '100%',
          padding: '10px',
          border: '1px solid #ccc',
          borderRadius: '5px',
          marginBottom: '10px',
        }}
      />
      <button
        onClick={() => handleSubmitComment(review.id)}
        style={{
          padding: '10px 15px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
        }}
      >
        Submit Comment
      </button>
        </>
      )}
    </div>
            </li>
          ))}
        </ul>
      ) : (
        <p style={{ textAlign: 'center', color: '#666', fontStyle: 'italic' }}>No feedback yet.</p>
      )}



        <button
          onClick={() => navigate(`/public-films`)}
          style={{
            marginTop: '15px',
            padding: '10px 15px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            fontSize: '16px',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = '#0056b3')}
          onMouseLeave={(e) => (e.target.style.backgroundColor = '#007bff')}
        >
          Back to Public Films
        </button>
      </div>
  
     {/* Feedback categories and additional details on the right margin */}
<div
  style={{
    flex: 1,
    borderLeft: '1px solid #ccc',
    paddingLeft: '20px',
    border: '1px solid #ccc',
    borderRadius: '10px',
    backgroundColor: '#f3e5f5', // Light purple for the right section
  }}
>
 {/* Film Title */}
<h2 style={{ color: '#7b1fa2', marginBottom: '10px' }}>Film Title</h2>
<p style={{ color: '#333', fontWeight: 'bold', marginBottom: '20px' }}>
  {film.title || 'Untitled Film'}
</p>

{/* Feedback Categories */}
<h2 style={{ color: '#7b1fa2', marginBottom: '10px' }}>Feedback Categories</h2>
{film.feedback_categories && film.feedback_categories.length > 0 ? (
  <ul style={{ paddingLeft: '20px', listStyleType: 'disc' }}>
    {film.feedback_categories.map((category, index) => (
      <li key={index} style={{ marginBottom: '5px' }}>
        {category}
      </li>
    ))}
  </ul>
) : (
  <p style={{ color: '#666' }}>No feedback categories available.</p>
)}

{/* YouTube Link */}
<h2 style={{ color: '#7b1fa2', marginBottom: '10px', marginTop: '20px' }}>YouTube Link</h2>
<a
  href={film.youtube_link || '#'}
  target="_blank"
  rel="noopener noreferrer"
  style={{
    color: '#007bff',
    textDecoration: 'none',
    fontWeight: 'bold',
  }}
>
  {film.youtube_link ? 'Watch on YouTube' : 'No link available'}
</a>
</div>
    </div>
  );
}

export default SubmitReview;